import React from 'react';
import DetailCard, {
  DetailCardItem,
} from '@tcs/common/components/molecules/DetailCard';

interface RepresentativeInfoCardProps {
  representativeCode: string;
  name: string;
  firmName?: string;
}

const PersonalInfoCard = ({
  representativeCode,
  name,
  firmName,
}: RepresentativeInfoCardProps) => {
  return (
    <DetailCard title="Personal Information">
      <DetailCardItem label="Firm Name" value={firmName ?? 'N/A'} />
      <DetailCardItem label="Representative Code" value={representativeCode} />
      <DetailCardItem label="Name" value={name} />
    </DetailCard>
  );
};

export default PersonalInfoCard;
